import { AutomationType } from './process';

export const executionStatusType = {
  '0': 'InProgress',
  '1': 'Completed',
  '2': 'Cancelled',
  '3': 'WaitingForApproval',
  '4': 'Denied',
  '5': 'TimedOut',
  '6': 'Failed',
  '7': 'Submitted',
  '8': 'Draft'
} as const;

export type ExecutionStatusType = keyof typeof executionStatusType;

export enum ApprovalStatus {
  NotStarted = 'Not Started',
  Approved = 'Approved',
  Rejected = 'Rejected'
}

export enum ExecutionMetadataType {
  ApproverEmailLevel1 = 0,
  ApprovalStatusLevel1 = 1,
  ApprovalDateLevel1 = 2,
  ApproverEmailLevel2 = 3,
  ApprovalStatusLevel2 = 4,
  ApprovalDateLevel2 = 5,
  ApproverEmailLevel3 = 6,
  ApprovalStatusLevel3 = 7,
  ApprovalDateLevel3 = 8,
  DocumentReferenceId = 9,
  ScoreSetName = 10,
  OverrideRanking = 11,
  OverridePoints = 12,
  ExpirationDate = 13,
  OverrideComment = 14,
  ScoreSetId = 15,
  ScoreSetRankColor = 16,
  ScoreSetRankDescription = 17,
  OverrideRankingColor = 18,
  OverrideRankingDescription = 19,
  DocumentFileName = 20,
  DocumentFileSize = 21,
  DocumentMimeType = 22,
  DocumentId = 23,
  ContractorDocumentOrgId = 24,
  InitiatedByContractor = 25,
  MakeCallbackAttemptCount = 26,
  MakeCallbackLastError = 27,
  WorkflowPausedDateTimeUtc = 28,
  WorkflowResumedDateTimeUtc = 29,
  ClientName = 30,
  IncidentType = 31,
  IncidentStatus = 32,
  IncidentTitle = 33,

  // Override form reference data snapshot
  SsqId = 34,
  SsqProgressPercentage = 35,
  SsqModuleName = 36,
  ProgramReviewStatus = 37,
  ScoreSetPointsEarned = 38,
  ScoreSetPointsPossible = 39,
  RiskLevel = 40,
  EmrYear1 = 41,
  EmrYear2 = 42,
  EmrYear3 = 43,
  TrirYear1 = 44,
  TrirYear2 = 45,
  TrirYear3 = 46,
  RemedialActions = 47,
  PotentialSIF = 48,
  // Insurance variance table (stored as JSON array string)
  InsuranceVarianceTable = 49,
  // Overall status from clientContractorScores
  OverallStatus = 50,
  ContractorEhsManualStatus = 51,
  GeneralSafetyOrientationStatus = 52,
  // Questionnaire answer: Website Access (Yes/No)
  WebsiteAccess = 53,
  NumberOfEmployees = 54,
  // Multi-file upload components (stored as JSON array string)
  MultiFileUpload = 55,
  CustomFileUpload2 = 56,
  CustomMultiFileUpload2 = 57,
  // Multi-thread comments component (stored as JSON array string, each entry contains text, timestamp, role)
  MultiThreadComments = 58,
  Location = 59,
  ActualSIF = 62,
  SIFDetails = 63
}

export interface IExecutionMetadata {
  executionId: string;
  typeId: ExecutionMetadataType;
  data: string | null;
  type: string;
}

export interface IExecution {
  automationId: string;
  organizationId: string;
  contractorId: string;
  contractorName: string;
  customfileupload: string | null;
  externalWorkflowId: string;
  teamId: string;
  userId: string;
  status: ExecutionStatusType;
  createdDateTimeUtc: string;
  updatedDateTimeUtc: string;
  createdByName: string;
  startedById: string;
  updatedByName: string;
  updatedById: string;
  approvalStatus: ApprovalStatus;
  approverName: string;
  approverId: string;
  id: string;
  type: AutomationType;
  publicId: string;
  submissionId: string;
  executionMetadatas: IExecutionMetadata[];
  formData?: string;
  isDeleted?: boolean;
}
